// extracted by mini-css-extract-plugin
export default {"filter":"index_filter__JdDG2"};